import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs.ts';

export const CogniteVisualizableModel = z.object({
  ...InstanceIdType.shape,

  object3D: InstanceIdType.optional(),
});

/** @public */
export type CogniteVisualizableModelInput = z.input<typeof CogniteVisualizableModel>;
/** @public */
export type CogniteVisualizableModelOutput = z.output<typeof CogniteVisualizableModel>;
